<template>
    <div class="bundles-homepage">
        <div class="select-bundles">

            <template v-for="bundleGroup in bundlesGroups">
                <template
                    v-if="bundleGroup.assetId != '1526319530399' && bundleGroup.assetId != '1526321079406' && bundleGroup.assetId != '1526321302931' && bundleGroup.assetId != '1526321302511'">
                    <div class="selected-category" :data-id="bundleGroup.assetId"
                        :class="[activeBundleGroup.assetId == bundleGroup.assetId ? 'active-selected-category' : '']"
                        :key="bundleGroup.assetId" @click="handleBundleGroupSelection(bundleGroup)">
                        <img :src="bundleGroup.inactiveIcon" class="svg-nonactive-bundles">
                        <img :src="bundleGroup.activeIcon" class="svg-active-bundles">
                        {{ bundleGroup.title }}
                    </div>
                </template>
            </template>
        </div>
        <template v-if="activeBundleGroup.isEligibleToActivateBundles">
            <div class="more-bundles-tip" v-if="activeBundleGroup.description != null">
                <img src="/ext_files/prepaid/f2g/images/bundle_tip.svg">
                {{ activeBundleGroup.description }}
            </div>
        </template>
        <template v-else>
            <div class="more-bundles-tip" v-if="activeBundleGroup.descriptionNotEligibleToActivate != null">
                <img src="/ext_files/prepaid/f2g/images/bundle_tip.svg">
                {{ activeBundleGroup.descriptionNotEligibleToActivate }}
            </div>
        </template>
        <div class="list-bundles row row-f2g">
            <template v-for="bundle in activeBundleGroup.bundles">
                <BundleCard :instance="bundle" :key="bundle.assetId"></BundleCard>
            </template>
        </div>
        <div class="banner-colorful data-jump-banner bundle-banner"
            v-if="activeBundleGroup.assetId === '1526321163949' || activeBundleGroup.assetId === '1526321164163'">
            <img src="/ext_files/prepaid/f2g/images/data-jump.png" style="width: 80px; height: 80px;">
            <div>
                <div class="bold-title-banner">{{ words['myf2g.bundles.dataJump.title'] }}</div>
                <div v-html="words['myf2g.bundles.dataJump.subtitle']" class="main-text-banner hidden-xs hidden-sm">
                </div>
                <div v-html="words['myf2g.bundles.dataJump.subtitle']" class="main-text-banner hidden-lg hidden-md">
                </div>
            </div>
            <!-- <div class="btn-banner-logwin">
                <div class="container-button-banner">
                    <div class="container-button black-btn"
                        v-on:click="redirectTo('/gr/f2g/upiresies/online-ananeosi-hronou-omilias/online-ananeosi-hronou-omilias-meso-myf2g-/?dataJumpFlow=true')">
                        {{ 'Πάτα Εδώ' }}
                    </div>
                </div>
            </div> -->
        </div>
        <router-view />

    </div>
</template>

<script>

import store from '@/store/index'
import router from '@/router/index'
import BundleCard from '@/components/BundleCard'

export default {
    name: 'MainBundleView',
    components: {
        BundleCard
    },
    computed: {
        dataJumpResponse() {
            return this.dataJumpResponseValue;
        },
        locale() {
            return store.state.locale;
        },
        username() {
            return store.state.username;
        },
        bundlesGroups() {
            return store.state.bundlesGroups;
        },
        activeBundleGroup() {
            return store.state.activeBundleGroup;
        }
    },
    data() {
        return {
            dataJumpResponseValue: {},
            words: {}
        }
    },
    beforeMount() {
        //fetch wcs words
        if (sessionStorage.getItem("wcs_myf2bundlescard_" + this.locale) != null) {
            this.words = JSON.parse(sessionStorage.getItem("wcs_myf2bundlescard_" + this.locale));
        } else {

            let config = {
                method: 'get',
                url: '/gr/f2g/vueContentService/',
                params: {
                    ciKey: 'myf2bundlescard',
                    locale: this.locale,
                }
            }

            let self = this;
            this.axios(config).then(function (response) {
                console.log(response);
                self.words = response.data;
                sessionStorage.setItem("wcs_myf2bundlescard_" + self.locale, JSON.stringify(self.words));

            }).catch(function (error) {
                console.error(error);
            })

        }

    },
    mounted() {
        this.initializeSlick();
        this.handleSlickOnResize();
        this.changeLocaleURLPath(this.activeBundleGroup.friendlyUrl);
    },
    updated() {

        $('.select-bundles').each(function () {
            if ($(this).hasClass("slick-initialized")) {
                $(".selected-category").each(function () {
                    if (!$(this).hasClass("slick-slide")) {
                        $(this).addClass("slick-slide");
                    }
                })
            }
        })


    },
    methods: {

        handleBundleGroupSelection(bundleGroup) {

            this.changeLocaleURLPath(bundleGroup.friendlyUrl);

            router.push({
                path: bundleGroup.friendlyUrl
            })
        },
        changeLocaleURLPath(path) {

            var newUrl = "";

            if (this.locale == 'en_US') {
                newUrl = "/gr/f2g/paketa/#/" + path;
            } else {
                newUrl = "/en/f2g/bundles/#/" + path;
            }

            $(".lang-icon-header a").attr("href", newUrl);

        },
        initializeSlick() {
            $('.select-bundles').slick({
                accessibility: false,
                arrows: false,
                infinite: false,
                slidesToShow: 3,
                variableWidth: true,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 100,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        },
        handleSlickOnResize() {
            console.log("handleSlickOnResize mounted");
            $(window).on('resize', function () {
                console.log("handleSlickOnResize resized!!");
                if (!$('.select-bundles').hasClass("slick-initialized")) {
                    $('.select-bundles').slick({
                        accessibility: false,
                        arrows: false,
                        infinite: false,
                        slidesToShow: 3,
                        variableWidth: true,
                        mobileFirst: true,
                        responsive: [
                            {
                                breakpoint: 991,
                                settings: "unslick"
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 3,
                                }
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 2,
                                }
                            },
                            {
                                breakpoint: 100,
                                settings: {
                                    slidesToShow: 1,
                                }
                            }
                        ]
                    });
                }
            });
        }
    }
}
</script>